export const styles = {
  global: {
    ".js-focus-visible :focus:not([data-focus-visible-added])": {
      outline: "none",
      // boxShadow: "none",
    },
  },
};
